<div class="token-input" [ngClass]="'is-' + status">

  <div class="token-input__boxes">
    <input
      *ngFor="let digit of digits; let i = index; trackBy: trackByIndex"
      #box
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="1"
      class="token-input__box"
      [attr.aria-label]="'Dígito ' + (i + 1) + ' de ' + length"
      [attr.aria-invalid]="status === 'error'"
      [disabled]="disabled"
      [value]="digit"
      (input)="onInput($event, i)"
      (keydown)="onKeyDown($event, i)"
      (paste)="onPaste($event, i)"
      (focus)="onFocus($event)"
      (blur)="onBlur()"
    />
  </div>

  <p class="token-input__message token-input__message--error" *ngIf="status === 'error'" role="alert">
    <span class="material-icons-outlined">
      error_outline
    </span>
    {{ errorMessage }}
  </p>

  <p class="token-input__message token-input__message--success" *ngIf="status === 'success'" role="status">
    {{ successMessage }}
  </p>

  <p class="token-input__resend mt-4" *ngIf="status !== 'success'">
    <ng-container *ngIf="countdown > 0; else canResend">
      Reenviar código em {{ countdownLabel }}
    </ng-container>
    <ng-template #canResend>
      <button type="button" class="token-input__resend-btn" [disabled]="disabled" (click)="onResend()">
        Reenviar código
      </button>
    </ng-template>
  </p>
</div>
